import React from 'react'

import CheckIcon from '../../../../assets/images/check-circle.svg'
import WarningIcon from '../../../../assets/images/exclamation-circle.svg'

import './DataEntryStyles.less'

export interface ContentProps {
  nrOfcharsIcon: boolean
  lowercaseIcon: boolean
  uppercaseIcon: boolean
  oneNumberIcon: boolean
  specialCharIcon: boolean
}

const resolvePasswordRequirementIcon = (requirementMet: boolean) => {
  return <img src={requirementMet ? CheckIcon : WarningIcon} alt="icon" />
}

const PasswordPopoverContent = (props: ContentProps) => {
  let contentProps =
    props !== undefined
      ? props
      : {
          nrOfcharsIcon: false,
          lowercaseIcon: false,
          oneNumberIcon: false,
          specialCharIcon: false,
          uppercaseIcon: false,
        }

  return (
    <div className="pk--password-popover-content">
      <p>{resolvePasswordRequirementIcon(contentProps.nrOfcharsIcon)} At least 8 characters</p>
      <p>{resolvePasswordRequirementIcon(contentProps.lowercaseIcon)} At least one lowercase letter</p>
      <p>{resolvePasswordRequirementIcon(contentProps.uppercaseIcon)} At least one uppercase letter</p>
      <p>{resolvePasswordRequirementIcon(contentProps.oneNumberIcon)} At least one number</p>
      <p>{resolvePasswordRequirementIcon(contentProps.specialCharIcon)} At least one special character</p>
    </div>
  )
}

export default PasswordPopoverContent
